import { PhoneNumberInput } from '@sparelabs/nutshell-legacy'
import React, { SyntheticEvent, useState } from 'react'
import { FormContainer, InfoPrompt, ITermsSectionProps, StackedInputWithLabel, TermsSection } from 'src/components'
import { LinkText } from 'src/components/LinkText'
import { st } from 'src/locales/TranslationHelper'

interface IProps {
  terms: ITermsSectionProps['terms'] | undefined
  onSubmit: (phoneNumber: string) => void
  handleLinkClick: (event: SyntheticEvent) => void
  error?: string
  initialValue?: string
}

export const RiderAuthPhoneForm = ({
  terms,
  onSubmit,
  error,
  handleLinkClick,
  initialValue = '',
}: IProps): JSX.Element => {
  const [phoneNumber, setPhoneNumber] = useState<string>(initialValue)

  const handleSubmit = (event?: SyntheticEvent) => {
    event?.preventDefault()
    onSubmit(phoneNumber)
  }

  return (
    <FormContainer onSubmit={handleSubmit}>
      <InfoPrompt>
        {st.forms.auth.authPromptPart1({ method: st.forms.auth.phoneNumberLabel().toLocaleLowerCase() })}
        <LinkText onClick={handleLinkClick}>{st.forms.auth.emailLink()}</LinkText>
        {st.forms.auth.authPromptPart2()}
      </InfoPrompt>
      <StackedInputWithLabel
        label={st.forms.auth.phoneNumberLabel()}
        error={error}
        labelStyle={{ marginTop: '20px' }}
        renderInput={({ id }) => (
          <PhoneNumberInput id={id} value={phoneNumber} onChange={setPhoneNumber} onSubmit={handleSubmit} autoFocus />
        )}
      />
      <TermsSection terms={terms} continueButtonType='submit' />
    </FormContainer>
  )
}
